module.exports = __webpack_public_path__ + "static/media/lion.2f269cc7.png";